module.exports = __webpack_public_path__ + "img/1481.93981d1c.png";